const charpenteItemData = [
    {
        blocTitle: 'Je sélectionne mon essence de bois pour ma charpente',
        blocContent: [
            {
                imageUrl : '/assets/images/bureau-d-etude/brique-parpaing.png',
                title: 'EPICEA',
                // description: 'Terrace extérieure',
            },
            {
                imageUrl : '/assets/images/bureau-d-etude/beton.png',
                title: 'DOUGLAS',
                // description: 'Bardages extérieur',
            },
            {
                imageUrl : '/assets/images/bureau-d-etude/pierre.png',
                title: 'PIN SYLVESTRE',
                // description: 'Lambris intérieure',
            },
        ],
        isBlockA: true,
        hasInput: true,
        inputLabel: 'Votre charpente sera apparente ou non apparente :',
        inputDescription: 'Qualité visuelle accrue pour les bois apparents',
    },
    {
        blocTitle: 'Je sélectionne ma couverture de toiture',
        blocContent: [
            {
                imageUrl : '/assets/images/bureau-d-etude/charpente-1.png',
                title: 'FERME TRADITIONELLE',
                // description: 'Terrace extérieure',
            },
            {
                imageUrl : '/assets/images/bureau-d-etude/panne-passante.png',
                title: 'PANNES PASSANTES',
                // description: 'Bardages extérieur',
            },
            {
                imageUrl : '/assets/images/bureau-d-etude/chevrons-porteurs.png',
                title: 'CHEVRONS PORTEURS',
                // description: 'Lambris intérieure',
            },
            {
                imageUrl : '/assets/images/bureau-d-etude/ferme-banane.png',
                title: 'FERME BANANE',
                description: 'Type Tôle Acier',
            },
        ],
        isBlockA: false,
        isBlockCharpente: true,
        hasInput: false,
        inputLabel: '',
        inputDescription: '',
    },
]

export default charpenteItemData;